module.exports = __webpack_public_path__ + "img/back-2.1e7f1139.png";